import { productPriceInventory } from 'api/mdl22'
import { useDispatch, useSelector } from 'react-redux'
import {
  addToCart,
  emptyCart,
  getPayloadProduct,
  isLoadingProduct,
} from 'redux/actions/cartActions'
import {
  fethCheckFinalPrice,
  processWarranties,
  buildFinalProductsInOrder,
} from './checkFinalPriceUtils'

export const useCheckFinalPrice = () => {
  const dispatch = useDispatch()
  const company = useSelector(state => state.company)
  const cart = useSelector(state => state.cart.cart)

  const checkFinalPrice = async ({
    prods,
    customerId,
    newCompany,
    isClone,
  } = {}) => {
    dispatch(isLoadingProduct({ isLoadingAllProducts: true }))
    const allProducts = prods || cart
    if (!allProducts.length) {
      return dispatch(isLoadingProduct({ isLoadingAllProducts: false }))
    }

    // Separate warranty and regular products
    const productList = allProducts.filter(p => !p.IsExtendedWarranty)
    const warrantyProducts = allProducts.filter(p => p.IsExtendedWarranty)

    if (!productList.length && !warrantyProducts.length) {
      return dispatch(isLoadingProduct({ isLoadingProduct: false }))
    }

    const companyCode = newCompany?.CompanyCode || company.CompanyCode
    const companyId = newCompany?.CompanyId || company.CompanyId
    const WarehouseId = newCompany?.WarehouseId || company.WarehouseId

    const batches = []
    for (let i = 0; i < productList.length; i += 99) {
      batches.push(productList.slice(i, i + 99))
    }

    dispatch(emptyCart())

    for (const batch of batches) {
      const ProductIds = batch.map(product => product.ProductId)

      const combinedPayload = batch.map(prod => ({
        product: prod,
        qty: prod.Quantity,
      }))

      const priceInventoryPayload = {
        CompanyId: companyId,
        CompanyCode: companyCode,
        WarehouseId,
        ProductIds: ProductIds || [],
        UoMId: null,
        PriceListId: null,
      }
      const response = await productPriceInventory(priceInventoryPayload)
      const {
        data: { Data: updatedProducts },
      } = response

      const processedProducts = await fethCheckFinalPrice(
        combinedPayload,
        customerId,
        newCompany
      )

      const processedWarranties = processWarranties(
        warrantyProducts,
        newCompany
      )

      const orderedProducts = buildFinalProductsInOrder(
        allProducts,
        processedProducts || [],
        processedWarranties
      )

      orderedProducts?.forEach((orderedProduct, index) => {
        const updatedProduct = updatedProducts?.find(
          up => up.ProductId === orderedProduct.selectList.ProductId
        )
        if (updatedProduct) {
          orderedProducts[index].payload.product.Cost = updatedProduct.Cost
          orderedProducts[index].payload.product.AvgCost =
            updatedProduct.AvgCost
          orderedProducts[index].payload.product.AvgPrice =
            updatedProduct.AvgPrice
        }
      })

      for (const prod of orderedProducts) {
        // Warranty items are added directly (they already have correct price)
        if (prod.payload?.product?.IsExtendedWarranty) {
          dispatch(
            addToCart(prod.payload.product, prod.payload.product.Quantity || 1)
          )
          continue
        }

        const action = addToCart(
          getPayloadProduct(
            prod.selectList,
            prod.payload,
            prod.warehouse,
            prod.Quantity,
            prod.Price,
            isClone
          ),
          prod.qty
        )
        dispatch(action)
      }
    }
    dispatch(isLoadingProduct({ isLoadingAllProducts: false }))
  }

  return { checkFinalPrice }
}
